// src/components/Layout.js
import React from 'react';
import Sidebar from './Sidebar';
import { Outlet } from 'react-router-dom';
import CopilotPanel from './copilot/CopilotPanel';

const Layout = ({ userRole }) => {
  return (
    <div className="layout-container">
      <Sidebar userRole={userRole} />
      <div className="main-content">
        <Outlet />
      </div>
      {/* In-app copilot — admin only, mirrors the backend's 403 gate. */}
      {userRole === 'admin' && <CopilotPanel />}
    </div>
  );
};

export default Layout;
